var isDiscountSkip = 0; 
var strCouponCode  = 'B3PW59DPRR3E';
var tempCustMainQuizPopup = '';

//call apply function only for cart page and when session is set
if(jQuery('.cart').length > 0 && sessionStorage.getItem('custApplyCoupon') !== null ){
   applyAutoCouponCode(); 
}

function applyAutoCouponCode() {
    var intCount    = 0;
    var intInterval = setInterval(function (){
        intCount   += 1;
        if( jQuery('.cart #cart_form input.limoniapps-discountninja-cartdiscountfield-input').length > 0 && !jQuery('.cart #cart_form button.limoniapps-discountninja-cartdiscountfield-apply').hasClass('disabled')){
             jQuery('.cart #cart_form input.limoniapps-discountninja-cartdiscountfield-input').val(sessionStorage.getItem('custApplyCoupon'));
            jQuery('.cart #cart_form button.limoniapps-discountninja-cartdiscountfield-apply')[0].click();
            clearInterval(intInterval);
        }

        if(intCount === 60){
            clearInterval(intInterval);
        }
    },50);
}

//add new quiz changes
function addStickyBannerAndPopup(){
    if(sessionStorage.getItem('custTopQuizBannerClosed') === null ){
      jQuery('.custTopQuizBanner').removeClass('hidden');
      tempCustMainQuizPopup = jQuery('.custMainQuizPopup').clone();
      
      var intHeight = jQuery('.custTopQuizBanner').height();
      if(jQuery(window).width() > 1024){
          jQuery('.custTopQuizBanner + #header + .jsc-main-nav-menu.search-enabled--true').css('padding-top' , intHeight +'px');
      }else{
          jQuery('.custTopQuizBanner + #header.mobile_nav-fixed--true').css('top', intHeight + 'px');
          var intHeaderHeight = jQuery('header#header').height();
          jQuery('#shopify-section-header').css('padding-top', intHeaderHeight + 'px');
      }
    }else{
      jQuery('.custTopQuizBanner').remove();
    }
}

// initiate quiz banner
jQuery(document).ready(function(){
  if(quizIsHomePage){
    addStickyBannerAndPopup();  
  }
})

// Scroll functionality for the sticky header 
jQuery(window).scroll(function(){
    if(jQuery('.custTopQuizBanner').length > 0){
        var intHeight = jQuery('.custTopQuizBanner').height();
        jQuery('.custTopQuizBanner + #header.mobile_nav-fixed--true').css('top', intHeight + 'px');
        jQuery('.main-nav__wrapper.sticky_nav.sticky_nav--stick').css('top', intHeight + 'px');
    }
});

// Close functionality for Sticky Header Banner
jQuery(document).on('click', '.custTopQuizBanner .btn-close', function(){
    jQuery('.custTopQuizBanner').remove();
    sessionStorage.setItem('custTopQuizBannerClosed', 'yes');
    if(jQuery(window).width() > 1024){
        jQuery('#header + .jsc-main-nav-menu.search-enabled--true').css('padding-top' , '0px');
    }else{
        jQuery('#header.mobile_nav-fixed--true').css('top', '0px');
    }
    jQuery('.main-nav__wrapper.sticky_nav').css('top', '0px');
    jQuery('#shopify-section-header').css('padding-top', '0px');
});

// Close Functionality for the pop-up
jQuery(document).on('click', '.custMainQuizPopup .btn-close, .custMainQuizPopup .popupContainer .custQuizForm .formField a.custClosePopup, .custMainQuizPopup .overlay', function(){
    jQuery('.custMainQuizPopup').remove();
});

// Show Popup Functionality
jQuery(document).on('click', '.custTopQuizBanner .custOfferDealBtn .custTakeQuiz', function(){
    if(jQuery('.custMainQuizPopup').length == 0){
        // addStickyBannerAndPopup();
        jQuery(tempCustMainQuizPopup).clone().prependTo('body');
    }
    jQuery('.custMainQuizPopup').css('display', 'flex');
});

// Click functionality for Other CTA
jQuery(document).on('click', '.custMainQuizPopup .custNextCTA', function(){
    if(jQuery(this).attr('data-id') == 'step-1'){
        jQuery('.custMainQuizPopup .prodSelection.InitialStep').hide();
        jQuery('.custMainQuizPopup .prodSelection.nextStepOneGuide').show();
        jQuery('.custMainQuizPopup .popupContainer .progressBar .progressSteps').css('width', '45%');
    }else if(jQuery(this).attr('data-id') == 'step-2'){
        jQuery('.custMainQuizPopup .prodSelection.nextStepOneGuide').hide();
        jQuery('.custMainQuizPopup .prodSelection.nextStepTwoGuide').show();
        jQuery('.custMainQuizPopup .popupContainer .progressBar .progressSteps').css('width', '65%');
    }else if(jQuery(this).attr('data-id') == 'step-3'){
        jQuery('.custMainQuizPopup .prodSelection.nextStepTwoGuide').hide();
        jQuery('.custMainQuizPopup #chatSpecialist').show();
    }
});

// Skip functionality to skip the discount step and move to next step
jQuery(document).on('click', '.custMainQuizPopup #ProductSelectionQuiz .custBottomNavigation button.btn-skip', function(){
    var strProdTypeAttr = jQuery(this).attr('cust-data-type');
    setProdSizeData(strProdTypeAttr);
    jQuery('.custMainQuizPopup .popupContainer p.custBlueTag').hide();
    isDiscountSkip = 1;
});

// Back functionality for Step-2 and Step-3
jQuery(document).on('click', '.custMainQuizPopup #ProductSelectionQuiz button.btn-back', function(){
    if(jQuery(this).attr('data-step') == 'step-2'){
        jQuery('.custMainQuizPopup .prodSelection.nextStepOneGuide').hide();
        jQuery('.custMainQuizPopup .prodSelection.InitialStep').show();
        jQuery('.custMainQuizPopup .popupContainer .progressBar .progressSteps').css('width', '25%');
    }else if(jQuery(this).attr('data-step') == 'step-3'){
        jQuery('.custMainQuizPopup .prodSelection.nextStepTwoGuide').hide();
        jQuery('.custMainQuizPopup .prodSelection.nextStepOneGuide').show();
        jQuery('.custMainQuizPopup .popupContainer .progressBar .progressSteps').css('width', '45%');
    }else if(jQuery(this).attr('data-step') == 'step-4'){
        var strStepAttr = jQuery('.custMainQuizPopup .popupContainer .smallPopup .custQuizForm .formField button').attr('cust-data-type');
        if(strStepAttr == 'max') {
            jQuery('.custMainQuizPopup .InitialStep').show();
        }
        
        if(strStepAttr == 'regular') {
            jQuery('.custMainQuizPopup .nextStepOneGuide').show();
        }

        if(strStepAttr == 'acne' || strStepAttr == 'rosacea' || strStepAttr == 'arthritis'){
            jQuery('.custMainQuizPopup .nextStepTwoGuide').show();
        }

        jQuery('.custMainQuizPopup .prodSuggest').hide();
        jQuery('.custMainQuizPopup .popupContainer .progressBar .progressSteps').css('width', '65%');
    }else if(jQuery(this).attr('data-step') == 'step-5'){
        jQuery('.custMainQuizPopup .prodDiscount').hide();
        jQuery('.custMainQuizPopup .prodSuggest').show();
        jQuery('.custMainQuizPopup .popupContainer .progressBar .progressSteps').css('width', '85%');
    }else{
        jQuery('.custMainQuizPopup .prodSelection.nextStepOneGuide').hide();
        jQuery('.custMainQuizPopup .InitialStep').show();
        jQuery('.custMainQuizPopup .popupContainer .progressBar .progressSteps').css('width', '25%'); 
    }
});

// Click functionality for links
jQuery(document).on('click', ".custMainQuizPopup .popupContainer .prodListings ul li button:not('.custNextCTA')", function(){
    var strProdType = jQuery(this).attr('data-name');
    var strProdLink = strProdImage = '', strProdName = '', strFeatures = '', dc2oz = '', dc16oz = '';
    if(strProdType == 'regular'){
        strProdImage = 'https://cdn.shopify.com/s/files/1/0549/3181/6637/files/emuaid.jpg?v=1685429278';
        strProdName  = 'EMUAID';
        strFeatures  = '<li>Emuaid ist die letzte Salbe, die Ihre Haut jemals brauchen wird.</li><li>Es dringt nachweislich durch die äußerste Hautschicht und bietet Ihrer Haut (im Gegensatz zu den meisten auf dem Markt erhältlichen Salben) starke Heilungseffekte.</li><li>Hochwirksame natürliche Inhaltsstoffe in medizinischer Qualität beseitigen Infektionen, Juckreiz, Entzündungen, Schmerzen und Reizungen bei Ekzemen, Hämorrhoiden, Schuppenflechte und anderen Erkrankungen.</li>';
        dc2oz = 'Save 40%';
        dc16oz = 'Save 55%';
    }else if(strProdType == 'max'){
        strProdImage = 'https://cdn.shopify.com/s/files/1/0549/3181/6637/files/emuaidmax.jpg?v=1685428860';
        strProdName  = 'EMUAIDMAX';
        strFeatures  = '<li>EmuaidMAX ist die letzte Salbe, die Ihre Haut jemals brauchen wird.</li><li>Es dringt nachweislich durch die äußerste Hautschicht und bietet Ihrer Haut (im Gegensatz zu den meisten auf dem Markt erhältlichen Salben) starke Heilungseffekte.</li><li>Die Formel mit maximaler Stärke bietet leistungsstarke antibakterielle und antimykotische Eigenschaften, die helfen, die Symptome von schädlichen Infektionen wie Nagelpilz, Balanitis, Vaginitis und mehr zu beseitigen.</li>';
        dc2oz = 'Save 43%';
        dc16oz = 'Save 57%';
    }else if(strProdType == 'acne'){
        strProdImage = 'https://cdn.shopify.com/s/files/1/0549/3181/6637/files/acne-treatment.jpg?v=1685429331';
        strProdName  = 'EMUAID Overnight Acne Treatment';
        strFeatures  = '<li>EMUAID<sup>®️</sup> OVERNIGHT ACNE TREATMENT ist eine antibakterielle, antiseptische und klärende Zweiphasen-Akne-Lösung, die garantiert die Größe und den Schweregrad von Unreinheiten über Nacht reduziert.</li><li>Das Peeling entfernt porenverstopfende Ablagerungen, während eine spezielle Kombination natürlicher Inhaltsstoffe in die Poren eindringt, die Haut klärt und Infektionen bekämpft.</li><li>Beseitigt die hartnäckigsten Hautunreinheiten, Mitesser, zystische Akne und Rosacea.</li>';
    }else if(strProdType == 'rosacea'){
        strProdImage = 'https://cdn.shopify.com/s/files/1/0549/3181/6637/products/IMG-EMA-S444-003_5000x-REV_c591ecbf-9d17-42da-9655-804a5bb6d24d_2000x.jpg';
        strProdName  = 'Therapeutic Moisture Bar';
        strFeatures  = "<li>Eine perfekte Ergänzung zu EMUAID<sup data-uw-styling-context="true">®</sup> Erste-Hilfe-Salbe, EMUAID<sup data-uw-styling-context="true">®</sup> Therapeutic Moisture Bar tief reinigt und entgiftet die Haut, liefert intensive Hydratation und stellt Feuchtigkeit, Peeling, um den Zellumsatz zu fördern und stimuliert die natürliche Regeneration der Haut.</li><li>Verwendung für Gesicht und Körper - hervorragend für die Rasur oder das Shampoo.</li><li>Ohne Parabene, Phthalate, Paraffin, Gluten, Propylenglykol, Mineralöl, synthetische Duftstoffe, PABA, synthetische Farben, DEA oder Sulfate.</li>";
    }else if(strProdType == 'arthritis'){
        strProdImage = 'https://cdn.shopify.com/s/files/1/0549/3181/6637/files/relieving-cream.jpg?v=1685429370';
        strProdName  = 'EMUAID Pain Relieving Cream';
        strFeatures  = '<li>Dies ist die letzte Schmerzlinderungscreme, die Sie jemals brauchen werden.</li><li>Natürliche Schmerzlinderung in Minuten!</li><li>Entwickelt für eine tiefer gehende Schmerzlinderung bei schmerzenden Muskeln, Gelenken, Rückenschmerzen, Nervenschmerzen, Entzündungen und Arthritis.</li>';
    }else{
        strProdImage = 'https://cdn.shopify.com/s/files/1/0549/3181/6637/files/emuaidmax.jpg?v=1685428860';
        strProdName  = 'EMUAIDMAX';
        strFeatures  = '<li>EmuaidMAX ist die letzte Salbe, die Ihre Haut jemals brauchen wird.</li><li>Es dringt nachweislich durch die äußerste Hautschicht und bietet Ihrer Haut (im Gegensatz zu den meisten auf dem Markt erhältlichen Salben) starke Heilungseffekte.</li><li>Die Formel mit maximaler Stärke bietet leistungsstarke antibakterielle und antimykotische Eigenschaften, die helfen, die Symptome von schädlichen Infektionen wie Nagelpilz, Balanitis, Vaginitis und mehr zu beseitigen.</li>';
    }

    jQuery('.custMainQuizPopup .popupContainer #checkProduct.smallPopup .custQuizForm .formField a').attr('href', strProdLink);
    jQuery('.custMainQuizPopup .popupContainer .imageContainer img.custProdImage').attr('src', strProdImage);
    jQuery('.custMainQuizPopup .popupContainer h2 span.custProdName').text(strProdName)
    jQuery('.custMainQuizPopup .popupContainer .custProductsBloks ul').html(strFeatures);
    jQuery('.custMainQuizPopup .prodDiscount .dc2oz').text(dc2oz);
    jQuery('.custMainQuizPopup .prodDiscount .dc16oz').text(dc16oz);
    jQuery('.custMainQuizPopup .popupContainer .smallPopup .custQuizForm .formField button').attr('cust-data-type',strProdType);
    jQuery('.custMainQuizPopup .popupContainer .smallPopup .custBottomNavigation .btn-skip').attr('cust-data-type',strProdType);
    jQuery('.custMainQuizPopup .prodSelection').hide();
    jQuery('.custMainQuizPopup #weSuggest').show();
    jQuery('.custMainQuizPopup .popupContainer .progressBar .progressSteps').css('width', '65%');
});

// Click functionality Reveal Doscount CTA 
jQuery(document).on('click', '.custMainQuizPopup .popupContainer .smallPopup .custQuizForm .formField button.custRevealDiscountCTA', function(){
    var strEmail = jQuery("#custKlEmail").val().trim();
    var regex    = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;    
    if(strEmail == "" || !regex.test(strEmail)){
        jQuery('.custMainQuizPopup .popupContainer .custQuizForm .formField span.customError').show();
    }else{
        jQuery('.custMainQuizPopup .popupContainer .custQuizForm .formField span.customError').hide();
        if(document.getElementById("email_53614150") !== null){
            document.getElementById("email_53614150").value = strEmail;
            document.getElementById("email_53614150").dispatchEvent(new Event("input"));
        }

        // Save data on klavio
        if(jQuery("#weSuggest .custQuizForm .klaviyo-form .go3894874857").length > 0){
            jQuery("#weSuggest .custQuizForm .klaviyo-form .go3894874857").attr('id', 'custKlaviyoCTA');
          
            setTimeout(function(){
                document.getElementById("custKlaviyoCTA").click();
            }, 350);
        }
        
        var strProdTypeAttr = jQuery(this).attr('cust-data-type');
        setProdSizeData(strProdTypeAttr);
        jQuery('.custMainQuizPopup .popupContainer p.custBlueTag').show();
        isDiscountSkip = 0;                
    }
});


function setProdSizeData(strProdTypeAttr){
    if(strProdTypeAttr == 'max'){
            jQuery('#quizeDiscount .custStepNumber').html('<b>Schritt 2:</b> Select your Optimal Size');
            jQuery('.custAutomaticallyApplied ul li a:eq(0)').attr('href','https://www.emuaid.com/products/emuaidmax-first-aid-ointment-0-5oz');
            jQuery('.custAutomaticallyApplied ul li h4:eq(0)').html('0.5oz (14ml)');
            jQuery('.custAutomaticallyApplied ul li span:eq(0)').html('$1.99/ml');
            jQuery('.custAutomaticallyApplied ul li img:eq(0)').attr('src','https://cdn.shopify.com/s/files/1/0549/3181/6637/files/product-selection-14ml.jpg?v=1685428860');
            
            jQuery('.custAutomaticallyApplied ul li a:eq(1)').attr('href','https://www.emuaid.com/products/emuaidmax-3');
            jQuery('.custAutomaticallyApplied ul li h4:eq(1)').html('2oz (59ml)');  
            jQuery('.custAutomaticallyApplied ul li span:eq(1)').html('$1.08/ml');
            jQuery('.custAutomaticallyApplied ul li img:eq(1)').attr('src','https://cdn.shopify.com/s/files/1/0549/3181/6637/files/product-selection-59ml.jpg?v=1685428860');

            jQuery('.custAutomaticallyApplied ul li a:eq(2)').attr('href','https://www.emuaid.com/products/emuaidmax-first-aid-ointment-16oz');
            jQuery('.custAutomaticallyApplied ul li h4:eq(2)').html('16oz (480ml)'); 
            jQuery('.custAutomaticallyApplied ul li span:eq(2)').html('$0.80/ml'); 
            jQuery('.custAutomaticallyApplied ul li img:eq(2)').attr('src','https://cdn.shopify.com/s/files/1/0549/3181/6637/files/product-selection-475ml.jpg?v=1685429497');
             jQuery('.custAutomaticallyApplied ul li:eq(1),.custAutomaticallyApplied ul li:eq(2)').show();
        }
        else if(strProdTypeAttr == 'regular'){
            jQuery('#quizeDiscount .custStepNumber').html('<b>Schritt 2:</b> Select your Optimal Size');
            jQuery('.custAutomaticallyApplied ul li a:eq(0)').attr('href','https://www.emuaid.com/products/emuaid-first-aid-ointment-0-5oz');
            jQuery('.custAutomaticallyApplied ul li h4:eq(0)').html('0.5oz (14ml)');
            jQuery('.custAutomaticallyApplied ul li span:eq(0)').html('$1.57/ml');
            jQuery('.custAutomaticallyApplied ul li img:eq(0)').attr('src','https://cdn.shopify.com/s/files/1/0549/3181/6637/files/emuaid14ml.jpg?v=1685429584');
            
            jQuery('.custAutomaticallyApplied ul li a:eq(1)').attr('href','https://www.emuaid.com/products/emuaid-2');
            jQuery('.custAutomaticallyApplied ul li h4:eq(1)').html('2oz (59ml)');  
            jQuery('.custAutomaticallyApplied ul li span:eq(1)').html('$0.90/ml');
            jQuery('.custAutomaticallyApplied ul li img:eq(1)').attr('src','https://cdn.shopify.com/s/files/1/0549/3181/6637/files/emuaid59ml.jpg?v=1685429634');

            jQuery('.custAutomaticallyApplied ul li a:eq(2)').attr('href','https://www.emuaid.com/products/emuaid-first-aid-ointment-16oz');
            jQuery('.custAutomaticallyApplied ul li h4:eq(2)').html('16oz (475ml)'); 
            jQuery('.custAutomaticallyApplied ul li span:eq(2)').html('$0.67/ml');
            jQuery('.custAutomaticallyApplied ul li img:eq(2)').attr('src','https://cdn.shopify.com/s/files/1/0549/3181/6637/files/emuaid475ml.jpg?v=1685429634'); 
            jQuery('.custAutomaticallyApplied ul li:eq(1),.custAutomaticallyApplied ul li:eq(2)').show();
        }
        else if(strProdTypeAttr == 'acne'){
            jQuery('#quizeDiscount .custStepNumber').html('<b>Schritt 2:</b> Select your Personalized Product');
            jQuery('.custAutomaticallyApplied ul li a:eq(0)').attr('href','https://www.emuaid.com/products/overnight-acne-treatment');
            jQuery('.custAutomaticallyApplied ul li h4:eq(0)').html('Overnight Acne Treatment');
            jQuery('.custAutomaticallyApplied ul li span:eq(0)').html(''); 

            jQuery('.custAutomaticallyApplied ul li img:eq(0)').attr('src','https://cdn.shopify.com/s/files/1/0549/3181/6637/files/acne-treatment-small.jpg?v=1685429728'); 

            jQuery('.custAutomaticallyApplied ul li:eq(1),.custAutomaticallyApplied ul li:eq(2)').hide();
        }
        else if(strProdTypeAttr == 'arthritis'){
            jQuery('#quizeDiscount .custStepNumber').html('<b>Schritt 2:</b> Select your Personalized Product');
            jQuery('.custAutomaticallyApplied ul li a:eq(0)').attr('href','https://www.emuaid.com/products/emuaid-pain-relieving-cream');
            jQuery('.custAutomaticallyApplied ul li h4:eq(0)').html('Pain Relieving Cream');
            jQuery('.custAutomaticallyApplied ul li span:eq(0)').html(''); 
            jQuery('.custAutomaticallyApplied ul li:eq(1),.custAutomaticallyApplied ul li:eq(2)').hide();

            jQuery('.custAutomaticallyApplied ul li img:eq(0)').attr('src','https://cdn.shopify.com/s/files/1/0549/3181/6637/files/relieving-cream-small.jpg?v=1685429728');
        }
        else if(strProdTypeAttr == 'rosacea'){
            jQuery('#quizeDiscount .custStepNumber').html('<b>Schritt 2:</b> Select your Personalized Product');
            jQuery('.custAutomaticallyApplied ul li a:eq(0)').attr('href','https://www.emuaid.com/products/therapeutic-moisture-bar');
            jQuery('.custAutomaticallyApplied ul li h4:eq(0)').html('Therapeutic Moisture Bar');
            jQuery('.custAutomaticallyApplied ul li span:eq(0)').html(''); 
            jQuery('.custAutomaticallyApplied ul li:eq(1),.custAutomaticallyApplied ul li:eq(2)').hide();

            jQuery('.custAutomaticallyApplied ul li img:eq(0)').attr('src','https://cdn.shopify.com/s/files/1/0549/3181/6637/products/IMG-EMA-S444-003_5000x-REV_c591ecbf-9d17-42da-9655-804a5bb6d24d_2000x.jpg');
        }
        else{
            jQuery('#quizeDiscount .custStepNumber').html('<b>Schritt 2:</b> Select your Optimal Size');
            jQuery('.custAutomaticallyApplied ul li a:eq(0)').attr('href','https://www.emuaid.com/products/emuaidmax-first-aid-ointment-0-5oz');
            jQuery('.custAutomaticallyApplied ul li h4:eq(0)').html('0.5oz (14ml)');
            jQuery('.custAutomaticallyApplied ul li span:eq(0)').html('$1.99/ml');
            jQuery('.custAutomaticallyApplied ul li img:eq(0)').attr('src','https://cdn.shopify.com/s/files/1/0549/3181/6637/files/product-selection-14ml.jpg?v=1685428860');
            
            jQuery('.custAutomaticallyApplied ul li a:eq(1)').attr('href','https://www.emuaid.com/products/emuaidmax-3');
            jQuery('.custAutomaticallyApplied ul li h4:eq(1)').html('2oz (59ml)');  
            jQuery('.custAutomaticallyApplied ul li span:eq(1)').html('$1.08/ml');
            jQuery('.custAutomaticallyApplied ul li img:eq(1)').attr('src','https://cdn.shopify.com/s/files/1/0549/3181/6637/files/product-selection-59ml.jpg?v=1685428860');

            jQuery('.custAutomaticallyApplied ul li a:eq(2)').attr('href','https://www.emuaid.com/products/emuaidmax-first-aid-ointment-16oz');
            jQuery('.custAutomaticallyApplied ul li h4:eq(2)').html('16oz (480ml)'); 
            jQuery('.custAutomaticallyApplied ul li span:eq(2)').html('$0.80/ml'); 
            jQuery('.custAutomaticallyApplied ul li img:eq(2)').attr('src','https://cdn.shopify.com/s/files/1/0549/3181/6637/files/product-selection-475ml.jpg?v=1685429497');
            jQuery('.custAutomaticallyApplied ul li:eq(1),.custAutomaticallyApplied ul li:eq(2)').show();
        }
        jQuery('.custMainQuizPopup #weSuggest').hide();
        jQuery('.custMainQuizPopup #quizeDiscount').show();
        jQuery('.custMainQuizPopup .popupContainer .progressBar .progressSteps').css('width','85%');
}

// Click functionality View Product CTA 
jQuery(document).on('click', '.custMainQuizPopup .popupContainer #checkProduct.smallPopup .custQuizForm .formField a', function(){
    sessionStorage.setItem('custTopQuizBannerClosed', 'yes');
});

//on click of size, set discount coupon 
jQuery(document).on('click','.custAutomaticallyApplied ul li a', function () {
    if(!isDiscountSkip){
        sessionStorage.setItem('custApplyCoupon',strCouponCode) ;
    }           
});